import * as React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { UserNotificationAvatar } from '../user_notification_avatar/UserNotificationAvatar';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { withRouter } from 'react-router';
import { Avatar } from 'antd';
import { getAvatarStyle } from '../../utils/ImageUtils';

const moment = require('moment');

const UserNotificationRowDisplay: React.FC<any> = ({
	history,
	notification,
	userType,
	updateUserNotificationForBuyer,
	updateUserNotificationForSupplier,
	style,
}) => {
	const handleUserNotificationClick = () => {
		const appDomainRegex =
			userType === ROLE_TYPES.BUYER
				? /https:\/\/app\.useopenwrench\.com(.+)/i
				: /https:\/\/partners\.useopenwrench\.com(.+)/i;

		const notificationCapture = nullSafeGet(
			`${userType}PushNotification.webAppUrl`,
			notification
		).match(appDomainRegex);
		const notificationUrl = notificationCapture[1];
		const updateUserNotification =
			userType === ROLE_TYPES.BUYER
				? updateUserNotificationForBuyer
				: updateUserNotificationForSupplier;
		const newNotification = {
			...notification,
			hasSeen: true,
		};
		updateUserNotification(newNotification);
		if (notificationUrl && notificationUrl.length > 0) {
			history.push(notificationUrl);
		}
	};

	if (!notification) {
		return null;
	}
	const hasContact = nullSafeGetOrElse(
		`${userType}PushNotification.initiatedBuyerContact`,
		notification,
		nullSafeGet(`${userType}PushNotification.initiatedSupplierContact`, notification)
	);
	const getInitialsfromNotification = (str) => {
		const words = str.split(' ');
		if (words.length > 1) {
			return words[0].charAt(0) + words[1].charAt(0);
		} else {
			return words[0].charAt(0);
		}
	};
	return (
		<div
			onClick={handleUserNotificationClick}
			style={{
				...style,
				fontWeight: `${notification.hasSeen}` === 'false' ? 'bold' : '',
			}}
			className="flex cursor-pointer items-center border-0 border-b border-solid border-gray-300 px-2 py-3 group-hover:opacity-75"
		>
			<div style={{ marginRight: 20 }}>
				{hasContact ? (
					<ContactAvatar
						size={40}
						userType={userType}
						contact={nullSafeGetOrElse(
							`${userType}PushNotification.initiatedBuyerContact`,
							notification,
							nullSafeGet(`${userType}PushNotification.initiatedSupplierContact`, notification)
						)}
					/>
				) : (
					<Avatar size={40} style={getAvatarStyle(getInitialsfromNotification(notification.title))}>
						{getInitialsfromNotification(notification.title)}
					</Avatar>
				)}
			</div>
			<div>
				<div
					style={{
						fontSize: 14,
						marginBottom: 4,
						color: 'rgba(0,0,0,0.85)',
					}}
				>
					{notification.title}
				</div>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						marginRight: 4,
					}}
				>
					<UserNotificationAvatar userType={userType} notification={notification} />

					<span className="leading-2 ml-2 inline-block text-sm text-gray-500">
						{moment(notification.datetime).fromNow()}
					</span>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	updateUserNotificationForBuyer: (entity) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.update(entity)),
	updateUserNotificationForSupplier: (entity) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.update(entity)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserNotificationRowDisplay));
